import script from "./employee-onboarding-documents.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-onboarding-documents.vue?vue&type=script&setup=true&lang=js"

import "./employee-onboarding-documents.vue?vue&type=style&index=0&id=37dfa778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37dfa778"]])

export default __exports__